import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import FAQ from './pages/faq';
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import ProgramDetails from "./pages/ProgramDetails";
import ClarkPage from "./pages/clark";
import SecurityPage from "./pages/security";
import ScrollToHashElement from "./components/ScrollToHashElement";

function ReviewRedirect() {
  window.location.replace("https://www.google.com/search?sca_esv=35308fe20e06e5ed&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOdWM7p-A24kmKzCepcCWMqoE5CZZWFuo1AvCRnDBY_WKPx1Vb2Gqu8VWq3Awydgp-GkKkIdgNynoiD2zmvm3mAE0Eam02qq33QbMG_sh8vKBhufkN8I4Xzqqi_o8pT65cdi3OCigJQ_G-CxYPqqNcsk5NRGQ2UWBJRFGrj2E-7Os0i9CgRglOZUNMw54vCCSndv-9YY%3D&q=%CE%9A%CE%95%CE%9A+%CE%98%CE%97%CE%A3%CE%95%CE%91%CE%A3+%CE%9A%CE%94%CE%92%CE%9C+-+%CE%9A%CE%95%CE%A4%CE%96%CE%95%CE%A4%CE%96%CE%97%CE%A3+%CE%A3+%CE%A6%CE%9F%CE%A5%CE%A1%CE%9B%CE%97%CE%A3+%CE%93+%CE%9F%CE%95+%CE%9A%CF%81%CE%B9%CF%84%CE%99%CE%BA%CE%AD%CF%82&sa=X&ved=2ahUKEwjwhaqj7tuUAxUIQvEDHSs9Me8Q0bkNegQIJxAH&biw=1920&bih=919&dpr=1#lrd=0x14aebbe2035bdc2d:0x37f7a43f2f3764f0,3");
  return null;
}

function App() {
  return (
    <Router>

      <ScrollToHashElement />

      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/review" element={<ReviewRedirect />} />
            <Route path="/" element={<Home />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/programs/:slug" element={<ProgramDetails />} />
            <Route path="/clark" element={<ClarkPage />} />
            <Route path="/security" element={<SecurityPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <Analytics />
    </Router>
  );
}



export default App;